import { Link } from "react-router"

interface NavbarItemProperties {
  img: string
  link: string
  title: string
  name: string
  tasksIncomplete?: boolean
  picked: boolean
  isDark?: boolean
}

const NavbarItem = ({
  img,
  link,
  title,
  name,
  tasksIncomplete,
  picked,
  isDark,
}: NavbarItemProperties) => {
  return (
    <Link
      className="after:bg-hint-color/50 relative basis-1/3 pb-3 after:absolute after:bottom-[30%] after:right-0 after:top-[10%] after:w-[0.5px] last:after:hidden"
      to={link}
    >
      <div
        className={`flex flex-col items-center justify-center filter ${name === "" && "gap-1.5"} ${picked && (isDark ? "brightness-150" : "brightness-50")}`}
      >
        <div className="relative flex h-[28px] w-[28px] justify-center">
          <img src={img} alt="logo" />
        </div>
        <div className={`text-hint-color text-xs`}>{title}</div>
      </div>
      {name === "quests" && tasksIncomplete && (
        <div className="bg-mission-dot absolute right-[16px] top-0 h-[8px] w-[8px] rounded-2xl" />
      )}
    </Link>
  )
}

export default NavbarItem
